import { IconTruck, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'
import {
  RegularBenefitVariant,
  RegularFreeShipping,
} from '../../../../../../../typings'
import { ShippingVariantView } from '../../../../../../ShippingVariantSelector/View'
import { ViewProps } from '../../View'
import { messages } from './messages'

type Props = ViewProps & {
  config: RegularFreeShipping
}

export function FreeShippingView(props: Props) {
  const { onEdit, onRemove, config } = props

  const handleEdit = () => onEdit(RegularBenefitVariant.FreeShipping)

  return (
    <Rule onClick={handleEdit}>
      <RuleIcon>
        <IconTruck />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.title}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Tag>
          <FormattedMessage {...messages.free} />
        </Tag>
        <ShippingVariantView config={config} />
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={handleEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
